module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"export":"Export","keyword":"Keyword","page":"Page","volume":"Volume","position":"Rank","actions":"Actions"},"fr":{"export":"Export","keyword":"Mot clé","page":"Page","volume":"Volume","position":"Position","actions":"Actions"},"de":{"export":"Export","keyword":"Stichwort","page":"Buchseite","volume":"Volumen","position":"Position","actions":"Aktionen"}}')
  delete Component.options._Ctor
}
